import {
  RECETAS_DE_GUIA,
  buscarRecetas,
  recetaVisiblePara,
  type RecetaDeGuia,
} from '@conversia/shared-types';
import { enlaceAPantalla } from './mapa-sistema';

/**
 * El motor de "Muéstrame", la parte PURA: a dónde ir y qué señalar en cada paso.
 *
 * Lo que toca la pantalla (navegar, iluminar, escuchar el toque) vive en
 * `components/guia/GuiaEnCurso.tsx`; acá solo se decide, para poder probarlo.
 */

/** La pantalla (con filtros) donde tiene que estar la persona en el paso `i`. */
export function destinoDelPaso(receta: RecetaDeGuia, i: number): string | null {
  for (let k = Math.min(i, receta.pasos.length - 1); k >= 0; k -= 1) {
    const paso = receta.pasos[k]!;
    if (paso.ruta) return enlaceAPantalla(paso.ruta, paso.filtros ?? {});
  }
  return null;
}

/**
 * ¿Hay que navegar al empezar el paso `i`? Solo cuando el paso declara pantalla
 * y la persona no está parada en ella (misma ruta Y mismos filtros). Un paso sin
 * pantalla sigue donde quedó el anterior: un modal abierto no se cierra.
 */
export function hayQueNavegar(receta: RecetaDeGuia, i: number, dondeEsta: string): string | null {
  const paso = receta.pasos[i];
  if (!paso?.ruta) return null;
  const destino = destinoDelPaso(receta, i);
  if (!destino) return null;
  return mismaPantalla(destino, dondeEsta) ? null : destino;
}

function mismaPantalla(a: string, b: string): boolean {
  const [rutaA, qsA = ''] = a.split('?');
  const [rutaB, qsB = ''] = b.split('?');
  if (rutaA !== rutaB) return false;
  const pa = new URLSearchParams(qsA);
  const pb = new URLSearchParams(qsB);
  for (const [k, v] of pa) if (pb.get(k) !== v) return false;
  return true;
}

/** "Paso 2 de 3". */
export function progresoDelPaso(receta: RecetaDeGuia, i: number): string {
  return `Paso ${i + 1} de ${receta.pasos.length}`;
}

/** El selector del elemento a iluminar. */
export function selectorDelPaso(receta: RecetaDeGuia, i: number): string | null {
  const paso = receta.pasos[i];
  return paso ? `[data-guia="${paso.ancla}"]` : null;
}

export function esUltimoPaso(receta: RecetaDeGuia, i: number): boolean {
  return i >= receta.pasos.length - 1;
}

/**
 * Las guías del menú "¿Cómo hago…?". Sin texto: todas las que este rol puede
 * usar, por título. Con texto: las que responden esa pregunta. PURO.
 */
export function guiasParaMostrar(busqueda: string, rol: string | undefined): RecetaDeGuia[] {
  const q = busqueda.trim();
  if (!q) {
    return RECETAS_DE_GUIA.filter((r) => recetaVisiblePara(r, rol)).sort((a, b) =>
      a.titulo.localeCompare(b.titulo, 'es'),
    );
  }
  return buscarRecetas(q, rol, 8);
}
